
import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import { Tile } from 'carbon-components-react';
import { useHistory } from 'react-router-dom';
import callGetApi from '../../requests/GetRequests';
import * as Constants from '../../requests/URLConstants';
import automate from 'assets/image/automatemodularmanagement.svg';
import planninganalytics from 'assets/image/planninganalytics.svg';
import dashboard from 'assets/image/dashboard.svg';
import ArrowRight from 'assets/image/ArrowRight.svg';
import '@carbon/ibmdotcom-web-components/es/components/carousel/carousel.js';
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import i18n from "../../i18n";
import callPostApi from "../../requests/PostRequests";
import * as workspaces from 'config/WorkspaceConstants';
import * as config from "../../config/Constants";

require("./_home-page.scss");

const HomePage = props => {
    const [value, onChange] = useState(new Date());
    const [calendarEvents, setCalendarEvents] = useState([]);
    const [filteredEvents, setFilteredEvents] = useState([]);
    const [workspace, setWorkspace] = React.useState("");

    const history = useHistory();

    const carouselSectionHeading = i18n.t('homepage.carouselSectionHeading');
    const releaseVersion = i18n.t('homepage.releaseVersion');
    const calendarHeading = i18n.t('homepage.calendarHeading');
    const carousel1Line1 = i18n.t('homepage.carousel.carousel1Line1');
    const carousel1Line2 = i18n.t('homepage.carousel.carousel1Line2');
    const carousel2Line1 = i18n.t('homepage.carousel.carousel2Line1');
    const carousel2Line2 = i18n.t('homepage.carousel.carousel2Line2');
    const carousel3Line1 = i18n.t('homepage.carousel.carousel3Line1');
    const carousel3Line2 = i18n.t('homepage.carousel.carousel3Line2');
    const carousel1Button = i18n.t('homepage.carousel.carousel1Button');
    const carousel2Button = i18n.t('homepage.carousel.carousel2Button');
    const carousel3Button = i18n.t('homepage.carousel.carousel3Button');
    const card1title = i18n.t('homepage.highlights.card1title');
    const card1details = i18n.t('homepage.highlights.card1details');
    const card2title = i18n.t('homepage.highlights.card2title');
    const card2details = i18n.t('homepage.highlights.card2details');
    const card3title = i18n.t('homepage.highlights.card3title');
    const card3details = i18n.t('homepage.highlights.card3details');
    const card4title = i18n.t('homepage.highlights.card4title');
    const card4details = i18n.t('homepage.highlights.card4details');
    const card5title = i18n.t('homepage.highlights.card5title');
    const card5details = i18n.t('homepage.highlights.card5details');
    const card6title = i18n.t('homepage.highlights.card6title');
    const card6details = i18n.t('homepage.highlights.card6details');
    const Planned = i18n.t('homepage.Planned');
    let carousetTiles = [
        //removed watchlist tile
        // {
        //     line1: carousel1Line1,
        //     line2: carousel1Line2,
        //     image: dashboard,
        //     button: carousel1Button
        // },
        // workspace === workspaces.automation_ops ? {
        workspace === workspaces.automation_ops && config.URL.includes(config.cibc)===false ? {
            line1: carousel2Line1,
            line2: carousel2Line2,
            image: automate,
            button: carousel2Button,
            link: "/automata"
        } : {},
        {
            line1: carousel3Line1,
            line2: carousel3Line2,
            image: planninganalytics,
            button: carousel3Button,
            link: "/analytics"
        }
    ]

    const releaseHighlights = [
        {
            "info": [
                {
                    "title": card1title,
                    "details": card1details
                },
                {
                    "title": card2title,
                    "details": card2details
                }
            ]
        },
        {
            "info": [
                {
                    "title": card3title,
                    "details": card3details
                },
                {
                    "title": card4title,
                    "details": card4details
                }
            ]
        },
        {
            "info": [
                {
                    "title": card5title,
                    "details": card5details
                },
                {
                    "title": card6title,
                    "details": card6details
                }
            ]
        }
    ];

    useEffect(() => {
        getCalendarEvents();
        getUserPreferences();
    },[]);

    useEffect(() => {
        let filteredEvents = filterEventsBySelectedDate(value);
        setFilteredEvents(filteredEvents);
    },[value, calendarEvents, workspace]);

    const getUserPreferences = () =>{
         //Check except login and login callback i.e. for protected routes.
          let user = JSON.parse(localStorage.getItem('user'));
          if(user){
          let body = { 'user': user.username };
         
          callPostApi(Constants.GETUSERPREFRENCESURL,{
            'Content-Type': 'application/json'
          }, body) .then(respJson => {
            if (respJson && respJson._source) {
              if (respJson._source.workspace) {     
                setWorkspace(respJson._source.workspace);     
              }
            } 
      
          }).catch((error) => {
            console.error('Error:', error);
          });
        }
      
        }
        
      
    function filterEventsBySelectedDate(date) {
        let events = [];
        let selectedDate = new Date(date);
        let eventDate;
        if(calendarEvents.length) {
            events = calendarEvents.filter(function (event) {
                selectedDate = moment(selectedDate).format("YYYY-MM-DD");
                eventDate = new Date(event.opened_at);
                eventDate = moment(eventDate).format("YYYY-MM-DD");
                return moment(selectedDate).isSame(moment(eventDate));
            });
        }
        return events;
    };

    function getCalendarEvents(date) {
        callGetApi(Constants.CHANGEMANAGEMENT, {
            'Content-Type': 'application/json'
        }).then(res => {
            setCalendarEvents(res);
        }).catch(error => {
            //console.log(error);
        });
    };

    return (
        <div className="home-page-container">
            {workspace !== "" ?

            <div className="home-page">
                {/* <div className="bx--grid--full-width"> */}
                    {/* <div className='main-content'> */}
                        <div className="page-cards">
                            <div className="carousel-background">
                            <div className="tile-heading carbon-display-Regular-14">{carouselSectionHeading}</div>
                            <div className="border-tile-predicted">
                                <div className="predicted-arrow">
                                </div>
                                <div className="predicted-values">
                                    <dds-carousel>
                                        {carousetTiles.map((tile, index) => (
                                            Object.keys(tile).length !== 0 && <Tile className="tile-container" key={index} onClick={() => history.push(tile.link)}>
                                                <div className="card-title">
                                                    <img src={tile.image} alt="" />
                                                </div>
                                                <div className="card-body">
                                                    <div>
                                                        <span className="card-body-spanupper">{tile.line1}</span>
                                                        <span className="card-body-spanupper">{tile.line2}</span>
                                                    </div>
                                                    <div className="card-body-bottom">
                                                        <div>
                                                            {tile.button}
                                                        </div>
                                                        <div className="icon-wrapper">
                                                            <img src={ArrowRight} alt=""/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Tile>
                                        ))}
                                    </dds-carousel>
                                </div>
                            </div>
                            </div>
                            <div className="highlights-container">
                            <div className="tile-headingbelow">{releaseVersion}</div>
                            <div className="highlights">
                                {releaseHighlights.map((highlight, index) => (
                                    <div className="info-column" key={index}>
                                        {highlight.info.map((info, i) => (
                                            <div className="card-container" key={i}>
                                                <div className="card-title">{info.title}</div>
                                                <div className="card-details carbon-display-Regular-14">{info.details}</div>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>
                        </div>
                        
                    {/* </div> */}
                    <div className="calender-content">
                        <div className="calendar-title carbon-display-Regular-20">
                            {calendarHeading}
                        </div>
                        <div className="calendar-tile">
                            <Calendar
                                onChange={onChange}
                                value={value}
                            />
                        </div>
                        <div className="calendar-events-container">
                            {filteredEvents.map((event, index) => (
                                <div className="event carbon-display-Regular-14" key={index}>
                                {Planned}: {event.description}
                                {moment(event.opened_at).format('MMMM Do YYYY | h:mm:ss A')} | GMT
                                </div>
                            ))}
                            {/* <div className="event carbon-display-Regular-14">
                                Planned: Deploy service improvements to some clusters
                                10 Nov., 2020 | 10:00 PM | Frankfurt
                            </div> */}
                        </div>
                    </div>
                {/* </div> */}
            </div>: null}
        </div>

    );
};

export default HomePage;
